import { Component } from '@angular/core';
import { DwLanguageService } from '@webdpt/framework';
import { SseService } from './notification/sse.service';

@Component({
  selector: 'app-root',
  template: `
  <router-outlet></router-outlet>
  `,
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(langService: DwLanguageService,sseService:SseService) {}
   //David Lee 05Aug2024 测试
  // @HostListener('window:beforeunload', ['$event'])
  // beforeUnloadHandler(event: Event) {
  //   // 在这里处理刷新事件
  //   console.log('DavidLee：刷新事件触发');
  // }
}
